module.exports = __webpack_public_path__ + "static/img/icon-recall.c293b278.svg";